<template>
    <Layout>
        <b-modal
                id="modalUpload"
                scrollable
                title="Subir archivo"
                title-class="font-18"
                size="lg"
                no-close-on-esc
                hide-footer
                centered
        >
            <subirArchivos v-on:upload-complete="uploadComplete" />
        </b-modal>

        <div class="card">
            <form class="needs-validation" @submit.prevent="formSubmit">
            <b-overlay :show="isLoading" rounded="sm">
                <div class="card-body">
                    <div class="form-row">
                        <div class="form-group col-md-9">
                            <label>Expediente</label>
                            <v-select
                                    :options="expedientes"
                                    label="obra_expediente"
                                    :reduce="desc=>desc.expediente_id"
                                    v-model="expediente_id"
                                    @input="cargarPartidasyAvance()"
                                    :class="{ 'is-invalid': submitted && $v.expediente_id.$error }"
                            />
                            <div v-if="submitted && $v.expediente_id.$error" class="invalid-feedback">
                                <span v-if="!$v.expediente_id.required">Este valor es requerido.</span>
                            </div>
                        </div>

                        <div class="form-group col-md-3">
                            <label>Fecha</label>
                            <VueCtkDateTimePicker
                                    v-model="fecha"
                                    :locale="'es'"
                                    :input-size="'sm'"
                                    :format="'YYYY-MM-DD'"
                                    :formatted="'YYYY-MM-DD'"
                                    :range="false"
                                    :auto-close="true"
                                    :only-date="true"
                                    :no-header="true"
                                    @input="cargarAvance()"
                                    :class="{ 'is-invalid': submitted && $v.fecha.$error }"
                            />
                            <div v-if="submitted && $v.fecha.$error" class="invalid-feedback">
                                <span v-if="!$v.fecha.required">Este valor es requerido.</span>
                            </div>
                        </div>

                    </div>
                    <div class="form-row" v-if="$can('cronograma-modificar')">
                        <div class="form-group col-md-12">
                            <label>Partida</label>
                            <v-select
                                    :options="partidas"
                                    label="descripcion"
                                    v-model="partida"
                                    :class="{ 'is-invalid': submitted && $v.partida.$error }"
                            />
                            <div v-if="submitted && $v.partida.$error" class="invalid-feedback">
                                <span v-if="!$v.partida.required">Este valor es requerido.</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-row" v-if="$can('cronograma-modificar')">
                        <div class="form-group col-md-2">
                            <label>Cantidad</label>
                            <input
                                    class="form-control"
                                    v-model="cantidad"
                                    :class="{ 'is-invalid': submitted && $v.cantidad.$error }"
                                    :disabled="disable_cantidad"
                                    @input="calcularSubtotal()"
                            >
                            <div v-if="submitted && $v.cantidad.$error" class="invalid-feedback">
                                <span v-if="!$v.cantidad.required">Este valor es requerido.</span>
                                <span v-if="!$v.cantidad.numeric">Solo se acepta numeros.</span>
                            </div>
                        </div>
                        <div class="form-group col-md-2">
                            <label>C.U.</label>
                            <input class="form-control" v-model="costo_unitario" :disabled="disable_costo_unitario">
                        </div>
                        <div class="form-group col-md-2">
                            <label>Parcial</label>
                            <input class="form-control" v-model="subtotal" :disabled="disable_subtotal">
                        </div>
                        <div class="form-group col-md-4">
                            <button type="submit" class="btn btn-primary mt-4">Agregar</button>
                            <button type="button" class="btn btn-primary mt-4 ml-2" v-on:click="guardarLista">Guardar</button>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <ag-grid-vue
                                    style="width: 100%; height: 400px"
                                    class="ag-theme-balham"
                                    :columnDefs="columnDefs"
                                    :gridOptions="gridOptions"
                                    @grid-ready="onGridReady"
                                    :context="context"
                                    :rowData="rowData"
                                    :enterMovesDownAfterEdit="true"
                                    :singleClickEdit="true"
                            >
                            </ag-grid-vue>
                        </div>

                        <div class="col-md-12 text-right mt-4">
                            <h4>Total:S/ {{total}}</h4>
                        </div>
                    </div>
                </div>
            </b-overlay>
            </form>

        </div>


    </Layout>
</template>

<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";
    //import PageHeader from "@/components/page-header";
    import subirArchivos from "@/components/subir-archivos";

    /* eslint-disable vue/no-unused-components */
    import deleteButton from  "@/components/delete-button";

    import {/*email, maxLength, minLength,*/numeric, required} from "vuelidate/lib/validators";

    //import constantes from "../../../config/Constantes";
    /**
     * Dashboard Component
     */
    export default {
        page: {
            title: "Avance",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {
            Layout,
            //PageHeader,
            subirArchivos,
            deleteButton,
        },
        data() {
            return {

                title: "Avance",
                items: [
                    {
                        text: "Avance",
                        href: "/"
                    },
                    {
                        text: "Lista",
                        active: true
                    }
                ],
                isLoading: false,
                gridApi: null,
                columnApi: null,
                gridOptions: {
                    defaultColDef: {
                        sortable: true,resizable: true
                    },
                },

                columnDefs:[],
                rowData:[],
                expedientes:[],
                expediente_id:null,
                total:0,
                fecha:null,
                partida:null,
                partidas:[],
                cantidad:"",
                costo_unitario:0,
                subtotal:0,
                submitted: false,



                context:null,
                disable_subtotal:true,
                disable_cantidad:false,
                disable_costo_unitario:false,

                ////OLD/////////

                ////////////////
            };
        },

        methods: {

            cargarPartidasyAvance(){
              this.cargarPartidas();
              this.cargarAvance();
            },
            guardarLista(){
                this.isLoading=true;
                this.axios.post(process.env.VUE_APP_BACKEND +"/api/cronograma/guardar-lista",{
                    lista:this.getAllRows()
                })
                .then(() => {
                    this.cargarAvance();
                })
                .catch(()=>{
                  this.$swal('Cuidado',"Error guardando",'warning');
                })
                .finally(()=>this.isLoading=false)
            },
            calcularSubtotal(){
              if(this.partida.tipo_costo=="Costo directo"){
                  this.subtotal=this.costo_unitario*this.cantidad;
              }
            },
            cargarExpedientes(){
                this.isLoading=true;
                this.axios.get(process.env.VUE_APP_BACKEND + "/api/expedientes")
                    .then((response)=>{
                        this.expedientes=response.data;
                    })
                    .finally(()=>this.isLoading=false)
            },
            cargarPartidas(){
                this.isLoading=true;
                this.axios.get(process.env.VUE_APP_BACKEND +"/api/expediente/partidas/"+this.expediente_id)
                    .then((response) => {
                     this.partidas= response.data.partidas;
                    ///this.total=response.data.total;
                    //this.rowData=response.data;
                })
                .finally(()=>this.isLoading=false)
            },
            cargarAvance(){
                this.isLoading=true;
                this.axios.get(process.env.VUE_APP_BACKEND + "/api/cronograma/reporte/"+this.expediente_id+'/'+this.fecha
                )
                .then((response)=>{
                    this.rowData=response.data.partidas;
                    this.total=response.data.total;
                    //this.cast();
                })
                .finally(()=>this.isLoading=false)
            },
            getAllRows() {
                let rowData = [];
                this.gridApi.forEachNode(node => rowData.push(node.data));
                return rowData;
            },
            cast(){
                this.gridApi.setRowData(this.rowData);
            },
            formSubmit() {
                this.submitted = true;
                // stop here if form is invalid
                this.$v.$touch();
                if(this.$v.$error==false){
                    this.agregar();
                }
                else
                {
                    console.log("Formulario no valido");
                }
            },
            //////////////OLD
            agregar(){
                this.isLoading=true;
                this.axios.post(process.env.VUE_APP_BACKEND + "/api/cronograma",
                    {
                        expediente_id:this.expediente_id,
                        partida_id:this.partida.id,
                        cantidad:this.cantidad,
                        costo_unitario:this.costo_unitario,
                        tipo_costo:this.partida.tipo_costo,
                        fecha:this.fecha,
                        subtotal:this.subtotal
                    }
                )
                .then((response)=>{
                    console.log(response);

                    this.cargarAvance();
                })
                .catch((r)=>{
                    this.$swal('Cuidado',r.response.data.mensaje,'warning');
                })
                .finally(()=>this.isLoading=false)
            },
            borrar(row){
                this.$swal.fire({
                    title: '¿Esta seguro?',
                    text: "No se puede revertir esta accion!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Si, borralo!'
                }).then((result) => {
                    if (result.value) {
                        this.isLoading=true;
                        this.axios.delete(process.env.VUE_APP_BACKEND +'/api/cronograma/'+row.id)
                        .catch(()=>{
                            this.$swal('error','Error eliminando','error');
                        })
                        .finally(
                            ()=>
                            {
                                this.isLoading=false;
                                this.cargarAvance();
                            }
                        );
                    }
                })
            },
            ////////////////////
            abrirCarga(){
                this.$bvModal.show("modalUpload");
            },
            cargarOpciones(){

            },

            cellValueChanged(params){
                if(params.column.colId=="cantidad"){
                    this.calcular();
                }
            },
            calcular(){
                this.rowData=this.getAllRows();
                for(var i=0;i<this.rowData.length;i++){
                    this.rowData[i].subtotal=Math.round(this.rowData[i].cantidad*this.rowData[i].costo_unitario * 100) / 100;
                }
                this.cast();
            },
            rowDoubleClicked(){
              //alert("double click")
            },
            onGridReady(params) {
                this.gridApi = params.api;
                this.gridColumnApi = params.columnApi;
                this.gridApi.addEventListener('cellValueChanged',this.cellValueChanged);
                this.gridApi.addEventListener('rowDoubleClicked',this.rowDoubleClicked);
            },
            isCellEditable(params) {
                return params.data.tipo_costo === 'Costo directo';
            },
            uploadComplete(files){
                this.isLoading=true;
                this.axios.post(process.env.VUE_APP_BACKEND + "/api/estudiantes/procesar-lista",
                    {
                        file:files,
                    })
                    .then((response)=>{
                        console.log(response);
                        this.rowData=response.data;
                        this.$bvModal.hide("modalUpload");
                    })
                    .finally(()=>this.isLoading=false)
            },


        },
        watch:{
            partida:function (val){
                if(val.tipo_costo=="Costo directo"){
                    this.cantidad=0;
                    this.costo_unitario=val.costo_unitario;
                    this.subtotal=0;
                    this.disable_subtotal=true;
                    this.disable_cantidad=false;
                    this.disable_costo_unitario=false;
                }
                else
                {
                    this.costo_unitario=0;
                    this.cantidad=0;
                    this.subtotal=0;
                    this.disable_subtotal=false;
                    this.disable_cantidad=true;
                    this.disable_costo_unitario=true;
                }

            }
        },
        computed:{

        },
        beforeMount() {
            this.columnDefs= [
                { headerName: "ID", field: "id" ,width:50 ,hide: "true" },
                { headerName: "Tipo", field: "tipo",width:50 },
                { headerName: "Codigo", field: "codigo_partida",width:120 , filter: true,  floatingFilter: true, },
                { headerName: "Partida", field: "partida", width:350, filter: true,  floatingFilter: true, },
                {
                    headerName: "Cant",
                    field: "cantidad",
                    width:120,
                    editable: (params) =>((params.data.tipo == 'P') && (this.$can('cronograma-modificar'))),
                    cellStyle: (params) => {
                        if (this.isCellEditable(params)) {
                            return { backgroundColor: '#FFFFCD',textAlign: "right" };
                        }
                        else
                        {
                            return {textAlign: "right"};
                        }
                    },
                },
                { headerName: "C.U.", field: "costo_unitario", width:120,  cellStyle: {textAlign: "right"}},
                {
                    headerName: "Subtotal",
                    field: "subtotal",
                    width:120,

                    editable: (params)=>  ((params.data.tipo_costo == 'Costo indirecto') && (this.$can('cronograma-modificar'))),
                    cellStyle: (params) => {
                        if (params.data.tipo_costo == 'Costo indirecto') {
                            return { backgroundColor: '#FFFFCD',textAlign: "right" };
                        }
                        else
                        {
                            return {textAlign: "right"};
                        }
                    },

                },
                { headerName: "Fecha", field: "fecha",width:150 },
                { cellRenderer: 'deleteButton', hide:!this.$can('cronograma-modificar') },
                /*
                {
                    headerName: "Validado",
                    field: "validado",
                    resizable: true ,
                    width:"150px",
                    filter: true,
                    floatingFilter: true,
                },*/
            ];
            this.rowData= [

            ];
            this.context = { componentParent: this };

        },
        validations: {
            cantidad:{required,numeric},
            fecha:{required},
            expediente_id:{required},
            partida:{required},
        },

        mounted() {
            this.cargarExpedientes();

        },



    };
</script>
